import { useCallback } from "react";
import { useApiBase } from "../../base";

export function useGetPedido () {
    const {invocarApi, ...outrasPropriedades} = useApiBase();

    const getPedido = useCallback(
        (newPage: number) => {
            return invocarApi({
                url: `/api/v2/pedido`,
                method: "GET",
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getPedido,
    };
}